import { render, staticRenderFns } from "./prescription-list-popver.vue?vue&type=template&id=4d4720a0&scoped=true&"
import script from "./prescription-list-popver.vue?vue&type=script&lang=js&"
export * from "./prescription-list-popver.vue?vue&type=script&lang=js&"
import style0 from "./prescription-list-popver.vue?vue&type=style&index=0&id=4d4720a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4720a0",
  null
  
)

export default component.exports